module.exports = __webpack_public_path__ + "static/media/graph-background.2410c633.svg";